/*
  Product page option buttons (17 Oct, Martyn). Long option values such as "42mm (Series 10 & 11)" wrapped
  across two uneven lines on the Apple listings. Any value written as "Main (note)" is shown as the main part
  ("42mm") with the note ("Series 10 & 11") on a smaller second line, and a set of such buttons gets an even
  grid: 5 across on desktop, 3 on phones. The option values themselves are unchanged (only what's shown).
  Horizon redraws the picker when a choice changes, so this re-applies after each redraw.
*/
(function () {
  'use strict';
  var RE = /^(.+?)\s*\((.+)\)\s*$/;
  var css = '' +
    '.wss-split-set{grid-template-columns:repeat(5,minmax(0,1fr))!important}' +
    '@media (max-width:749px){.wss-split-set{grid-template-columns:repeat(3,minmax(0,1fr))!important}}' +
    '.wss-split-set .variant-option__button-label{height:auto!important;min-height:60px;padding-block:8px!important}' +
    '.wss-split-set .variant-option__button-label__text{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;line-height:1.15;text-align:center;white-space:normal}' +
    '.wss-opt-main{font-size:inherit;white-space:nowrap}' +
    '.wss-opt-sub{font-size:11px;font-weight:400;letter-spacing:.01em;opacity:.72;white-space:nowrap}' +
    '@media (max-width:389px){.wss-opt-sub{font-size:10px}}' +
    /* Stock line from assets/wss.js: green "In stock" with a dot; amber stays for "Only 2 left" (17 Oct, Martyn) */
    '.wss-low-stock.is-ok{color:var(--wss-green,#1f6b4f);display:flex;align-items:center;gap:7px}' +
    '.wss-low-stock.is-ok::before{content:"";flex:0 0 auto;width:8px;height:8px;border-radius:50%;background:currentColor}' +
    '.wss-low-stock.is-ok[hidden]{display:none}';
  function split() {
    if (!document.getElementById('wss-product-css')) {
      var st = document.createElement('style'); st.id = 'wss-product-css'; st.textContent = css; document.head.appendChild(st);
    }
    document.querySelectorAll('variant-picker fieldset').forEach(function (fs) {
      var spans = Array.prototype.slice.call(fs.querySelectorAll('.variant-option__button-label__text'));
      // Only option sets with at least one "Main (note)" value; others (e.g. strap widths, buckles) are left alone.
      var any = spans.some(function (t) { return t.querySelector('.wss-opt-main') || RE.test(t.textContent.trim()); });
      if (!any) return;
      spans.forEach(function (t) {
        if (t.querySelector('.wss-opt-main')) return;
        var m = t.textContent.trim().match(RE);
        var main = document.createElement('span'); main.className = 'wss-opt-main'; main.textContent = m ? m[1] : t.textContent.trim();
        var parts = [main];
        if (m) { var sub = document.createElement('span'); sub.className = 'wss-opt-sub'; sub.textContent = m[2]; parts.push(sub); }
        t.textContent = '';
        parts.forEach(function (p) { t.appendChild(p); });
      });
      if (!fs.classList.contains('wss-split-set')) fs.classList.add('wss-split-set');
    });
  }
  function start() {
    split();
    var root = document.querySelector('variant-picker');
    if (!root || !('MutationObserver' in window)) return;
    var t;
    // Watch the whole product form area: Horizon replaces the picker element itself on some redraws.
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(split, 30); })
      .observe(root.closest('.shopify-section') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  Options panel, option A (17 Oct, Martyn; canvas "WSS Product Options Panel").
  - One selected look for every option: teal fill (width already had it; buckle and the Length/Fitting chips now match).
  - The size note under the widths is a card: Length / At the buckle / In the box, a pointer up to the chosen
    width, and a footer with the sold-out widths and the size guide link. Figures come from the JSON that
    blocks/wss-spec-strip.liquid outputs (the same data assets/wss.js uses).
  - Even 28px between groups; the stock line sits under the basket button; the button runs the full width.
  Only writes to the page when something has actually changed, so it can't set off the other observers.
*/
(function () {
  'use strict';
  var css = '' +
    /* spacing: 28px between groups (parent gap is 22px) */
    '.product-information .variant-picker__form>fieldset:nth-of-type(n+2),.product-information .wss-fits{margin-top:6px!important}' +
    '.product-information .wss-spec{margin-top:-10px!important}' +
    /* stock line under the button */
    '.product-information .wss-restock{order:6!important}.product-information .buy-buttons-block{order:7!important;margin-top:6px}' +
    '.product-information .wss-low-stock{order:8!important;margin-top:-12px!important;font-size:13px}' +
    '.product-information .wss-promise{order:9!important;margin-top:6px}' +
    '.product-information .product-form-buttons>*,.product-information add-to-cart-component{width:100%;margin-inline:0!important;flex:1 1 100%}' +
    /* one selected look: buckle */
    '.product-information .variant-picker__form>fieldset:nth-of-type(2) .variant-option__button-label{border-radius:6px}' +
    '.product-information .variant-picker__form>fieldset:nth-of-type(2) .variant-option__button-label:has(:checked){background:var(--wss-green)!important;border-color:var(--wss-green)!important;box-shadow:none!important}' +
    '.product-information .variant-picker__form>fieldset:nth-of-type(2) .variant-option__button-label:has(:checked) .variant-option__button-label__text{color:#fff!important}' +
    '.product-information .variant-picker__form>fieldset:nth-of-type(2) .variant-option__button-label:has(:checked)::before{border-color:rgba(255,255,255,.5)}' +
    /* buckle values that are widths (deployment clasps, 18 Oct): no metal dot */
    '.product-information .wss-buckleset .variant-option__button-label:has(input[value$="mm"])::before{display:none!important}' +
    /* Length / Fitting chips */
    '.product-information .wss-sib[aria-current=page]{background:var(--wss-green)!important;border-color:var(--wss-green)!important;color:#fff!important;box-shadow:none!important}' +
    '.product-information .wss-sib[aria-current=page] small{color:rgba(255,255,255,.8)!important}' +
    /* width buttons: 6px corners like the rest */
    '.product-information .wss-widthset .variant-option__button-label,.product-information .wss-widthset .variant-option__button-label__pill{border-radius:6px}' +
    /* colour swatches: fixed size instead of stretching to fill the row (were ~41px desktop, ~50px phones) */
    '.product-information .wss-colourgrid{display:flex!important;flex-wrap:wrap;gap:10px;max-width:none}' +
    '.product-information .wss-colourgrid a{width:32px;height:32px;aspect-ratio:auto;position:relative;flex:0 0 auto}' +
    '.product-information .wss-colourgrid a::after{content:"";position:absolute;inset:-5px;border-radius:50%}' +
    '@media (max-width:749px){.product-information .wss-colourgrid a{width:36px;height:36px}}' +
    /* size card */
    '.product-information .wss-spec{position:relative}' +
    '.wss-spec.is-set{padding:16px 18px 12px;border-radius:8px;background:var(--wss-green-tint);border:0}' +
    '.wss-spec.is-set .wss-spec__set{display:flex;flex-direction:column;gap:12px;align-items:stretch}' +
    '.wss-spec__notch{position:absolute;top:-6px;left:24px;width:12px;height:12px;background:var(--wss-green-tint);transform:rotate(45deg);pointer-events:none}' +
    '.wss-spec__grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}' +
    '.wss-spec__cell{display:flex;flex-direction:column;gap:2px;min-width:0}' +
    '.wss-spec__k{font-size:11px;letter-spacing:.07em;text-transform:uppercase;color:#4a6a72}' +
    '.wss-spec__v{font-family:var(--font-heading--family,Archivo),sans-serif;font-weight:600;font-size:22px;line-height:1.15;color:var(--wss-ink)}' +
    '.wss-spec__s{font-size:13px;color:#3d4644}' +
    '.wss-spec__foot{display:flex;justify-content:space-between;align-items:baseline;gap:12px;border-top:1px solid #cad8d5;padding-top:10px;font-size:13px;color:#3d4644}' +
    '.wss-spec__foot [data-wss-c-sold]:empty::before{content:"Measurements for this width"}' +
    '.wss-spec.is-set .wss-spec__set a{margin-inline-start:auto;font-weight:600;color:var(--wss-green);white-space:nowrap}' +
    '@media (max-width:749px){.wss-spec.is-set{padding:14px}.wss-spec__v{font-size:19px}.wss-spec__k{font-size:10px}.wss-spec__grid{gap:10px}}';

  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function list(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }

  var data = null, scope = document;
  function load() {
    var el = document.querySelector('[data-wss-product-data]');
    if (!el) return false;
    try { data = JSON.parse(el.textContent); } catch (e) { return false; }
    scope = el.closest('.shopify-section') || document;
    return true;
  }

  function render() {
    if (!data || !data.widthName) return;
    var spec = scope.querySelector('[data-wss-spec]');
    if (!spec) return;
    var input = scope.querySelector('variant-picker input[data-option-name="' + CSS.escape(data.widthName) + '"]:checked');
    var fs = input && input.closest('fieldset');
    var chosen = fs && !fs.hasAttribute('data-wss-unchosen');
    var w = chosen ? input.value : null;
    var sz = w && data.sizes && data.sizes[w];
    if (!sz) return;
    // Deployment straps (18 Oct, Martyn): the buckle option is a clasp width such as "18mm", so the card shows
    // the one chosen rather than the size guide's "18mm or 20mm".
    var bIn = data.buckleName && scope.querySelector('variant-picker input[data-option-name="' + CSS.escape(data.buckleName) + '"]:checked');
    if (bIn && /^\d+(\.\d+)?mm$/i.test(bIn.value)) sz = { total: sz.total, c: sz.c, d: sz.d, b: String(parseFloat(bIn.value)) };

    setText(spec.querySelector('[data-wss-c-len]'), sz.total + 'mm');
    setText(spec.querySelector('[data-wss-c-split]'), sz.c ? sz.c + ' + ' + sz.d + 'mm' : 'Total length');
    var wn = parseFloat(w);
    var tapers = sz.b && parseFloat(sz.b) !== wn;
    setText(spec.querySelector('[data-wss-c-buckle]'), (tapers ? sz.b : wn) + 'mm');
    setText(spec.querySelector('[data-wss-c-taper]'), tapers ? 'Tapers from ' + w : 'No taper');

    // Widths with nothing in stock in any buckle
    var widths = [], seen = {};
    data.variants.forEach(function (v) { if (v.width && !seen[v.width]) { seen[v.width] = 1; widths.push(v.width); } });
    var sold = widths.filter(function (x) { return !data.variants.some(function (v) { return v.width === x && v.available; }); });
    var soldText = '';
    if (sold.length && sold.length <= 3) soldText = list(sold) + (sold.length === 1 ? ' is' : ' are') + ' sold out';
    else if (sold.length > 3) soldText = sold.length + ' widths are sold out';
    setText(spec.querySelector('[data-wss-c-sold]'), soldText);

    // Pointer up to the chosen width button
    var notch = spec.querySelector('[data-wss-notch]');
    var label = input.closest('label');
    if (notch && label) {
      var x = Math.round(label.getBoundingClientRect().left + label.offsetWidth / 2 - spec.getBoundingClientRect().left - 6);
      var max = spec.offsetWidth - 20;
      x = Math.max(8, Math.min(x, max));
      if (notch.style.left !== x + 'px') notch.style.left = x + 'px';
      // Only point when the chosen width is on the row just above the card (with 13 widths it may be on the top row).
      var away = spec.getBoundingClientRect().top - label.getBoundingClientRect().bottom > 24;
      if (notch.hidden !== away) notch.hidden = away;
    }
  }

  function start() {
    if (!document.getElementById('wss-options-css')) {
      var st = document.createElement('style'); st.id = 'wss-options-css'; st.textContent = css; document.head.appendChild(st);
    }
    if (!load()) return;
    var t;
    var later = function () { clearTimeout(t); t = setTimeout(render, 40); };
    render();
    // wss.js toggles the card (is-set) after a width is picked; Horizon redraws the picker on each choice.
    scope.addEventListener('change', later);
    scope.addEventListener('click', later);
    window.addEventListener('resize', later);
    if ('MutationObserver' in window) {
      var spec = scope.querySelector('[data-wss-spec]');
      if (spec) new MutationObserver(later).observe(spec, { attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
